import React from 'react'
import { AiOutlineDashboard } from "react-icons/ai";
import { MdOutlineDesignServices, MdOutlinePlayCircle, MdLink, MdCategory } from "react-icons/md";
import { FaClipboardList, FaRegSmile, FaBriefcase, FaImages } from "react-icons/fa";
import { Menu, Layout } from "antd";
import logo from "../assets/images/Text file.png";
import smallLogo from "../assets/images/logo glyph.png";
import { useNavigate } from 'react-router-dom';

const { Sider } = Layout;

function Sidebar({ collapsed }) {
    const navigate = useNavigate();
    const handleMenuClick = ({ key }) => {
        navigate(key);
    };

    return (
        <Sider
            trigger={null}
            collapsible
            collapsed={collapsed}
            className="sider"
            breakpoint="md"
            collapsedWidth="80"
        >
            <div className="logo text-center flex items-center justify-center py-3">
                <img
                    src={collapsed ? smallLogo : logo}
                    alt="Logo"
                    className="logo-img rounded-3"
                    style={{
                        width: collapsed ? "50px" : "90px",
                        transition: "width 0.3s",
                    }}
                />
            </div>
            <Menu
                className="min-h-screen"
                theme="dark"
                mode="inline"
                defaultSelectedKeys={["/admin"]}
                onClick={handleMenuClick}
                items={[
                    {
                        key: "/admin",
                        icon: <AiOutlineDashboard className="fs-4" />,
                        label: "Dashboard",
                    },
                    {
                        key: "/admin/service-type",
                        icon: <MdCategory className="fs-4" />,
                        label: "Service Type",
                    },
                    {
                        key: "/admin/main-services",
                        icon: <MdOutlineDesignServices className="fs-4" />,
                        label: "Main Services",
                    },
                    {
                        key: "/admin/sub-services",
                        icon: <FaClipboardList className="fs-4" />,
                        label: "Sub Services",
                    },
                    {
                        key: "/admin/sub-service-images",
                        icon: <FaImages className="fs-4" />,
                        label: "Sub Service Images",
                    },
                    {
                        key: "/admin/testimonials",
                        icon: <FaRegSmile className="fs-4" />,
                        label: "Testimonials",
                    },
                    {
                        key: "/admin/portfolio",
                        icon: <FaBriefcase className="fs-4" />,
                        label: "Portfolio",
                    },
                    {
                        key: "/admin/background-video",
                        icon: <MdOutlinePlayCircle className="fs-4" />,
                        label: "Background Video",
                    },
                    {
                        key: "/admin/links",
                        icon: <MdLink className="fs-4" />,
                        label: "Links",
                    },

                ]}
            />

        </Sider>

    )
}

export default Sidebar
